import { t } from "@/i18n-js/instance";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as p1DefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/PBlock/PBlockDefaultData";
import { p2DefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/PBlock/p2DefaultData";
import { p3DefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/PBlock/p3DefaultData";

export const PARAGRAPH_STYLES = ["p1", "p2", "p3"] as const;
export type ParagraphStyle = (typeof PARAGRAPH_STYLES)[number];

export const PARAGRAPH_DEFAULT_DATA: Readonly<
  Record<ParagraphStyle, BaseBlock>
> = {
  p1: p1DefaultData,
  p2: p2DefaultData,
  p3: p3DefaultData,
};

export const TEXT_SELECT_OPTIONS = PARAGRAPH_STYLES.map(style => ({
  value: style,
  label: t(`builder_ui.block_type.${style}`),
}));
